var map = {
	"./29.png": "KhyT",
	"./30.png": "qKVx",
	"./31.png": "TSze",
	"./32.png": "omHJ",
	"./33.png": "3l9I",
	"./34.png": "xsLr",
	"./35.png": "GT/Z",
	"./36.png": "sd7E",
	"./37.png": "i1nn",
	"./38.png": "kogS",
	"./39.png": "g115",
	"./44.png": "cExS",
	"./45.png": "TIII",
	"./51.png": "M9Am",
	"./52.png": "vUl5",
	"./53.png": "b48g",
	"./54.png": "Mxm/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8ts";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food ^\.\/.*\.png$
// module id = b8ts
// module chunks = 1